module.exports = __webpack_public_path__ + "img/album12_04.455a010b.jpg";